import React from 'react'
import PropTypes from 'prop-types'
import '../AdditionalReportFilters/css/AdditionalReportFilters.scss'

export const TabLabel = ({ children, isActive, tabName, onClick }) => {
  return (
    <div
      onClick={onClick(tabName)}
      className={`tab-label-tab ${isActive ? 'active' : 'hidden'}`}
    >
      {children}
    </div>
  )
}

TabLabel.propTypes = {
  tabName: PropTypes.string.isRequired,
  onClick: PropTypes.func,
  children: PropTypes.string.isRequired,
  isActive: PropTypes.bool.isRequired
}

export default TabLabel



// WEBPACK FOOTER //
// ./src/components/Tab/TabLabel.js